<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="selectionCode"
      cell-class-name="align-top"
      :toolbar-config="tableToolbar"
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :footer-method="() => footerData"
      show-footer
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-edit tool-btn" @click="openBatchDialog(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:whName="{ row }">
        <div>
          <span>{{ row.whName }} / {{ row.whRegionName }}</span>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>

    <el-dialog
      width="450px"
      :title="$l('form_label_edit_production_batch') || '编辑投产批次'"
      :visible.sync="batchDialogVisible"
    >
      <el-form label-position="top" :model="itemForm">
        <el-form-item :label="$l('form_label_specBeginDate') || '投产日期'">
          <el-date-picker
            v-model="itemForm.specBeginDate"
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
            style="width: 100%;"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          :label="$l('form_label_specProductionDays') || '生产天数'"
        >
          <el-input-number
            v-model="itemForm.specProductionDays"
            size="mini"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="$l('form_label_dailySpecQty') || '半成品日产能'">
          <el-input-number
            v-model="itemForm.dailySpecQty"
            size="mini"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          :label="$l('form_label_packersPerDay') || '成品包装投入人数'"
        >
          <el-input-number
            v-model="itemForm.packersPerDay"
            size="mini"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div class="d-flex justify-content-end">
        <el-button size="mini" @click="batchDialogVisible = false">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          type="primary"
          size="mini"
          @click="batchSave"
          :loading="saveLoading"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumn from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import { format, add } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    classification: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      format: (number) => format(number),
      batchDialogVisible: false,
      itemForm: {},
      saveLoading: false,
    }
  },
  computed: {
    tableColumns() {
      return tableColumn(this)
    },
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData?.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : ''
        })
      result[2] = this.$l('INDEX.total') || '合计'
      return [result]
    },
  },
  methods: {
    cellClassName({ column }) {
      return column.property === 'col-opt' ? '' : 'align-top'
    },
    openBatchDialog(row) {
      this.batchDialogVisible = true
      this.itemForm = { ...row }
    },
    batchSave() {
      this.saveLoading = true
      this.$api
        .evgPlanProductionBatchGenerateApi(this.itemForm)
        .then((res) => {
          this.saveLoading = false

          const { status, msg, body } = res
          if (status !== 200 || !body) {
            this.$message.error(`保存投产批次失败: ${msg}`)
            return
          }

          this.$eventBus.$emit('evg-planproduction-reload', body)
          this.batchDialogVisible = false
        })
        .catch((e) => {
          this.saveLoading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-toolbar {
    height: initial;
    margin-bottom: 12px;
  }
}
</style>
